import {ErrorMassage} from "../errorMassage";

export function MissingHeaders({missingHeaders, open, setOpen}) {
    const missingMessage = `הקובץ לא תקין, חסרות העמודות: ${missingHeaders?.join(', ')} `;
    const missingMessage1 = missingHeaders?.length > 1 ? missingMessage :
        missingMessage.replace('עמודות', 'עמודה')
            .replace('חסרות', 'חסרה');
    return <ErrorMassage error={missingMessage1} open={open} setOpen={setOpen}/>
}